import {
  CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_BEGIN,
  CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_SUCCESS,
  CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_FAILURE,
  CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
export function cloneCustomComponent(args = {}) {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_BEGIN,
    });
    const { projectId, version, customComponent } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/custom-component/clone-component/${
          customComponent.uuid || ''
        }`,
        {},
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_SUCCESS,
            data: res.data,
          });
          toast.success('Cloned Successfully !');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}` || 'Failed to Clone !');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCloneCustomComponentError() {
  return {
    type: CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_BEGIN:
      return {
        ...state,
        cloneCustomComponentPending: true,
        cloneCustomComponentError: null,
      };

    case CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_SUCCESS:
      return {
        ...state,
        cloneCustomComponentPending: false,
        cloneCustomComponentError: null,
        customComponents: [...state.customComponents, action.data],
      };

    case CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_FAILURE:
      return {
        ...state,
        cloneCustomComponentPending: false,
        cloneCustomComponentError: action.data.error,
      };

    case CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_DISMISS_ERROR:
      return {
        ...state,
        cloneCustomComponentError: null,
      };

    default:
      return state;
  }
}
